import { Plus } from 'lucide-react';

const AddAudienceCard = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-[#1c1c1c] hover:bg-[#2a2a2a] rounded-lg p-4 border-2 border-dashed border-gray-600 hover:border-gray-500 transition-all duration-200 h-full min-h-[140px] flex flex-col items-center justify-center group"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="bg-green-600 group-hover:bg-green-700 rounded-full p-3 transition-colors">
          <Plus size={24} className="text-white" />
        </div>
        <div className="text-center">
          <h3 className="text-white font-medium mb-1">Add Custom Audience</h3>
          <p className="text-gray-400 text-sm">Create your own audience</p>
        </div>
      </div>
    </button>
  );
};

export default AddAudienceCard; 